<template>
  <div class="auth-page login-email-page">
    <div class="auth-page__fields">
      <UIButton
        id="back-button"
        left-icon="back"
        class="auth-page__back"
        variant="ghost"
        @click="navigateTo({ name: 'login' })"
      >
        Back
      </UIButton>
      <div class="auth-page__title">Log in</div>
      <form ref="parentRef" class="auth-page__form" @submit.prevent="onSubmit">
        <UIInputText name="email" label="Email" placeholder="Email" />
        <UIInputText name="password" label="Password" placeholder="Password" type="password" />
        <div class="auth-page__form-remember">
          <UICheckbox v-if="!isMobile" id="remember" name="remember">Stay logged in</UICheckbox>
          <NuxtLink no-prefetch to="/reset"> Forgot my password </NuxtLink>
        </div>
        <UIButton id="login" :loading="isPending" type="submit" full-width>Log in</UIButton>
      </form>
      <div class="auth-page__description">
        Don't you have an account? <NuxtLink no-prefetch to="/signup">Sign up</NuxtLink>
      </div>
    </div>
    <div class="auth-page__img">
      <img width="521" height="714" src="/images/login-page-image.png" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useForm } from 'vee-validate'
import { SITE_NAME } from '~/constants'
import { loginSchema } from '~/schemas/auth/login'
import type { LoginDTO } from '~/types/auth'

useHead({
  title: `${SITE_NAME} | Log in  `,
})

definePageMeta({
  layout: 'auth',
  middleware: 'is-auth-route',
})

const { isMobile } = useAppBreakpoints()

const { handleSubmit } = useForm<LoginDTO & { message?: string }>({
  validationSchema: loginSchema,
  initialValues: {
    remember: isMobile,
  },
})

const { mutateAsync: login, isPending } = useLogin()

const { catchErrors } = useErrorHandler()

const onSubmit = handleSubmit(values => {
  login(values).catch(catchErrors)
})

const [parentRef] = useAutoAnimate()
</script>

<style scoped lang="scss">
@import '@/styles/variables.scss';
@import '@/styles/mixins.scss';

@include baseAuthPage();

.auth-page.login-email-page {
  .auth-page {
    &__form {
      &-remember {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 32px;

        @media screen and (max-width: 1023px) {
          flex-direction: column;
          gap: 8px;
          align-items: flex-start;
          margin-bottom: 24px;

          a {
            @include link();
            color: $black-80;
          }
        }
      }
    }
  }
}
</style>
